import React from 'react';

import {TabBarComponent} from '#/TabBar';
import TabBarItemComponent, {Props as TabBarItemProps} from '#/TabBar/Item';
import {GlobalTabBarItem} from '_/store/tabBar.store';
import {memo} from '_/utilities/memo';

import {StyledCasusTabBar, StyledCasusTabBarItem} from './CasusTabBar.styles';

export const CasusTabBar = memo(TabBarComponent, StyledCasusTabBar);

const CasusTabComponent = (
  props: TabBarItemProps<GlobalTabBarItem>,
  ref: React.Ref<HTMLAnchorElement>
): React.ReactElement => (
  <TabBarItemComponent splayCorner {...props} ref={ref} />
);

export const CasusTab = memo<
  (
    props: TabBarItemProps<GlobalTabBarItem>,
    ref: React.Ref<HTMLAnchorElement>
  ) => React.ReactElement,
  {active?: boolean; width?: number}
>(CasusTabComponent, StyledCasusTabBarItem, true);
